import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { colors } from '../../constants'
import { Button, Headings, Modal, Padding } from '..'
import { Divider, Buttons } from './Confirm.Styles'

class ConfirmDom extends PureComponent {
    static propTypes = {
        header: PropTypes.string.isRequired,
        content: PropTypes.node.isRequired,
        onClickCancel: PropTypes.func.isRequired,
        onClickAccept: PropTypes.func.isRequired,
        isOpen: PropTypes.bool.isRequired,
        isWorking: PropTypes.bool,
        t: PropTypes.func.isRequired,
    }

    static defaultProps = {
        isWorking: false,
    }

    render() {
        const { header, content, onClickCancel, onClickAccept, isOpen, isWorking, t } = this.props

        return (
            <Modal isOpen={isOpen} onClose={onClickCancel} confirm>
                <Padding size="sm">
                    <Headings.H2 color={colors.blue}>{header}</Headings.H2>
                    <Divider borderWidth="1px" />
                    <Padding size="sm" top>
                        {content}
                    </Padding>
                    <Padding size="sm" top>
                        <Buttons>
                            <Button theme="light" onClick={onClickCancel} size="xs">
                                {t('Cancel')}
                            </Button>
                            <Button onClick={onClickAccept} size="xs" disabled={isWorking}>
                                {t('Agree')}
                            </Button>
                        </Buttons>
                    </Padding>
                </Padding>
            </Modal>
        )
    }
}

export default withTranslation()(ConfirmDom)
